import { render, staticRenderFns } from "./KeyWordsUpsert.vue?vue&type=template&id=15399aae&scoped=true"
import script from "./KeyWordsUpsert.vue?vue&type=script&lang=js"
export * from "./KeyWordsUpsert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15399aae",
  null
  
)

export default component.exports